var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('EManageChallenge'),_c('EManageStructure'),_c('EManageAdvantage'),_c('EManageValue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }